<div class="datamodel-container">
  <p-toolbar styleClass="ml-2 mr-2">
    <div class="p-toolbar-group-start ml-1">
      <span class="mr-1" *ngIf="activeIndex() === 1 || activeIndex() === 2">
        <p-button
          label="{{ 'BACK' | translate }}"
          icon="pi pi-arrow-left"
          styleClass="section-btn"
          (onClick)="onback()"
        />
      </span>
      <div class="page-title"><vb-page-header></vb-page-header></div>
    </div>
    <div class="p-toolbar-group-end mr-3" [class.display-none]="isCompanionOrigin">
      <button
        (click)="toggleVisualizer()"
        [disabled]="isLoading || showLoader"
        [ngClass]="{
          'show-visualizer': !generateScript,
          'show-visualizer-rdbms': generateScript,
          'hide-visualizer': showVisualizer,
          'display-none': showDbVisualizer
        }"
        class="btn tree-btn btn-link icon-style hidden"
        type="button"
        *ngIf="activeIndex() === 0"
      >
        <svg-icon src="assets\images\svg\icon_visualizer.svg"></svg-icon>
        {{ showVisualizer === false ? ('SHOW_VISUALIZER' | translate) : ('HIDE_VISUALIZER' | translate) }}
      </button>

      <button
        (click)="toggleDbVisualizer()"
        [disabled]="isLoading || showLoader"
        [ngClass]="{
          'show-db-visualizer': true,
          'hide-db-visualizer': showDbVisualizer,
          'display-none': showVisualizer
        }"
        class="btn tree-btn btn-link icon-style ml-2"
        type="button"
        *ngIf="activeIndex() === 0"
      >
        <svg-icon src="assets/images/svg/icon_visualizer.svg"></svg-icon>
        {{ showDbVisualizer === false ? ('Show Visualizer' | translate) : ('Hide Visualizer' | translate) }}
      </button>
    </div>
  </p-toolbar>
  <div class="main-card data-model card sample-data" [class.mb-3]="!isBetaAccessPrivilegeConsumable">
    <div class="card-body">
      <div class="container-fluid">
        <div class="row">
          <div class="datamodel-column col-12 p-0 m-0" pageheight>
            <p-tabs class="data-model-column" [value]="activeIndex()" (valueChange)="activeIndex.set($event)">
              <p-tablist [class.display-none]="isCompanionOrigin">
                <p-tab [value]="0"></p-tab>
                <p-tab [value]="1">
                  <div class="sample-data-btn-container">
                    <button
                      class="btn tree-btn btn-primary mr-2 gen-btn"
                      (click)="confirmGeneration()"
                      *ngIf="activeIndex() === 1 && !disallowEdit"
                    >
                      {{ 'GENERATE_SAMPLE_DATA' | translate }}
                    </button>
                    <button
                      class="btn tree-btn btn-primary mr-2 gen-btn hide-btn"
                      (click)="onback()"
                      *ngIf="activeIndex() === 1 && !disallowEdit"
                    >
                      {{ 'HIDE_SAMPLE_DATA' | translate }}
                    </button>
                    <button
                      class="btn tree-btn btn-link icon-style"
                      [class.display-none]="showDbVisualizer"
                      type="button"
                      *ngIf="activeIndex() === 0 && !showVisualizer"
                      [disabled]="isLoading || showLoader"
                    >
                      <i class="fa-regular fa-file-lines"></i>
                      {{ 'SAMPLE_DATA' | translate }}
                    </button>
                  </div>
                </p-tab>
                <p-tab [value]="2">
                  <div
                    class="sample-data-btn-container"
                    (click)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()"
                    tabindex="0"
                  >
                    <div
                      class="query-string-btn"
                      style="display: inline-block"
                      *ngIf="activeIndex() === 0 && !showVisualizer"
                    >
                      <p-splitbutton
                        #qsBtn
                        [model]="queryStringItems"
                        icon="pi pi-ellipsis-v"
                        styleClass="p-button-text"
                        [menuStyleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
                        class="action-btn ellipsis-btn"
                        (onClick)="openDropdownMenu(qsBtn, $event)"
                        [disabled]="isLoading || showLoader"
                      >
                      </p-splitbutton>
                    </div>
                  </div>
                </p-tab>
              </p-tablist>
              <p-tabpanels>
                <p-tabpanel [value]="0">
                  <div class="tab-splitter-holder" [class.display-none]="showDbVisualizer" style="position: relative">
                    <div *ngIf="isCompanionLoading" class="companion-loading-overlay">
                      <p-progress-spinner></p-progress-spinner>
                    </div>
                    <p-splitter
                      [panelSizes]="panelSizes"
                      [minSizes]="[30, 70]"
                      [style]="{ height: '100%' }"
                      stateKey="dmSplitterKey"
                      stateStorage="local"
                      #splitter
                      class="dm-splitter"
                      (onResizeStart)="resizeStartHandler($event)"
                      (onResizeEnd)="resizeEndHandler($event)"
                    >
                      <ng-template #panel>
                        <div
                          style="display: flex; flex-direction: column"
                          class="tree-container"
                          [class.beta-tree-container]="isBetaAccessPrivilegeConsumable"
                          [class.beta-tree-table-parent]="isBetaAccessPrivilegeConsumable"
                        >
                          @if (isBetaAccessPrivilegeConsumable) {
                            <div class="table-header beta-table-header">
                              <div class="header d-flex">
                                <i class="fa fa-database beta-title-icon"></i>
                                {{ 'TABLES' | translate }}
                              </div>
                              <div class="beta-header-actions">
                                @if (!disallowEdit) {
                                  <button
                                    class="beta-header-icon-btn"
                                    type="button"
                                    (click)="showSchemaToDataModelModal()"
                                    showDelay="100"
                                    hideDelay="100"
                                    tooltipStyleClass="label-tooltip"
                                    pTooltip="{{ 'GEN_AI_IMPORT_TOOLTIP_TEXT' | translate }}"
                                    tooltipPosition="top"
                                  >
                                    <span class="beta-icon-mask beta-icon-upload-cloud"></span>
                                  </button>
                                }
                                <div
                                  class="formgroup-inline searchbox-button beta-searchbox-button"
                                  [class.expanded]="showBetaTableSearch || searchTerm"
                                >
                                  <div class="field">
                                    <div class="p-inputgroup datamodel-search beta-datamodel-search">
                                      <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                                      <input
                                        type="text"
                                        class="p-inputtext p-component p-element"
                                        placeholder="Search"
                                        aria-describedby="basic-addon1"
                                        [(ngModel)]="searchTerm"
                                        [ngModelOptions]="{ standalone: true }"
                                        (search)="filterTreeContent($event)"
                                        (keyup)="filterTreeContent($event)"
                                      />
                                      <span
                                        class="p-inputgroup-addon"
                                        *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
                                        (click)="clearFilter()"
                                        (keyup.enter)="clearFilter()"
                                        tabindex="0"
                                        ><i class="pi pi-times"></i
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  class="beta-header-icon-btn"
                                  type="button"
                                  [attr.aria-expanded]="showBetaTableSearch"
                                  (click)="showBetaTableSearch = !showBetaTableSearch"
                                >
                                  <i class="pi pi-search"></i>
                                </button>
                                <button
                                  class="beta-header-icon-btn"
                                  type="button"
                                  (click)="betaContextMenu.toggle($event)"
                                >
                                  <i class="pi pi-ellipsis-v"></i>
                                </button>
                                <p-menu #betaContextMenu [model]="menuItems" [popup]="true" appendTo="body" [styleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"></p-menu>
                                @if (!disallowEdit) {
                                  <p-splitbutton
                                    #betaBtn
                                    [model]="items"
                                    [label]="'Add'"
                                    icon="pi pi-plus"
                                    [disabled]="isLoading"
                                    styleClass="p-button-text"
                                    [menuStyleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
                                    class="action-btn add-btn btn-align-right beta-add-btn"
                                    (onClick)="openDropdownMenu(betaBtn, $event)"
                                  >
                                  </p-splitbutton>
                                }
                              </div>
                            </div>
                          } @else {
                            <div class="table-header">
                              <div class="header d-flex">
                                <i class="fa fa-database db-icon"></i>{{ 'TABLES' | translate }}
                              </div>
                              <div class="btn-container">
                                <div class="formgroup-inline searchbox-button">
                                  <div class="field">
                                    <div class="p-inputgroup datamodel-search">
                                      <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                                      <input
                                        type="text"
                                        class="p-inputtext p-component p-element"
                                        placeholder="Search"
                                        aria-describedby="basic-addon1"
                                        [(ngModel)]="searchTerm"
                                        [ngModelOptions]="{ standalone: true }"
                                        (search)="filterTreeContent($event)"
                                        (keyup)="filterTreeContent($event)"
                                      />
                                      <span
                                        class="p-inputgroup-addon"
                                        *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
                                        (click)="clearFilter()"
                                        (keyup.enter)="clearFilter()"
                                        tabindex="0"
                                        ><i class="pi pi-times"></i
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                                <div class="action-btns">
                                  <p-splitbutton
                                    #btn
                                    [model]="items"
                                    [label]="'Add'"
                                    icon="pi pi-plus"
                                    *ngIf="!disallowEdit"
                                    [disabled]="isLoading"
                                    styleClass="p-button-text"
                                    [menuStyleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
                                    class="action-btn add-btn btn-align-right"
                                    (onClick)="openDropdownMenu(btn, $event)"
                                  >
                                  </p-splitbutton>
                                  @if (!disallowEdit) {
                                    <button
                                      class="ai-import-btn"
                                      (click)="showSchemaToDataModelModal()"
                                      showDelay="100"
                                      hideDelay="100"
                                      tooltipStyleClass="label-tooltip"
                                      pTooltip="{{ 'GEN_AI_IMPORT_TOOLTIP_TEXT' | translate }}"
                                      tooltipPosition="top"
                                    >
                                      <i class="pi pi-download"></i> &nbsp; {{'IMPORT' | translate}} &nbsp;
                                      <span class="ai-badge"
                                        ><svg-icon src="assets\images\svg\ai-datamodel-import.svg"></svg-icon> AI</span
                                      >
                                    </button>
                                  }
                                  <p-splitbutton
                                    #btn1
                                    [model]="menuItems"
                                    icon="pi pi-ellipsis-v"
                                    [disabled]="isLoading"
                                    styleClass="p-button-text"
                                    [menuStyleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
                                    class="action-btn ellipsis-btn hidesysgenfields btn-align-right"
                                    (onClick)="openDropdownMenu(btn1, $event)"
                                  >
                                  </p-splitbutton>
                                </div>
                              </div>
                            </div>
                          }
                          <table id="tree" class="mr-0">
                            <colgroup>
                              <col width="0px;" />
                              <col width="0px;" />
                              <col width="65%" />
                              <col width="30%" />
                              <col width="5%" />
                            </colgroup>
                            <thead>
                              <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Define a row template for all invariant markup: -->
                              <tr>
                                <td></td>
                                <td></td>
                                <td>
                                  <div class="node-spinner d-none"></div>
                                </td>
                                <td class="field-type">
                                  <div class="dropdown dataTypes">
                                    <button
                                      class="btn dropdown-toggle toggle-button hidden"
                                      type="button"
                                      [disabled]="disallowEdit"
                                      id="data-field-type"
                                    >
                                      {{ 'STRING' | translate }}
                                    </button>
                                  </div>
                                </td>
                                <td class="context-menu-td">
                                  <div class="dropdown contextMenu">
                                    <p-button
                                      class="btn dropdown-toggle toggle-button hidden"
                                      icon="pi pi-ellipsis-v"
                                      type="button"
                                      [disabled]="disallowEdit"
                                      id="context-menu-trigger"
                                    >
                                    </p-button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ng-template>
                      <ng-template #panel>
                        <div style="display: flex; flex-direction: column; flex-grow: 1" class="tree-container_">
                          <div *ngIf="propertyLoading || showLoader" class="loading-model property">
                            <p-progress-spinner></p-progress-spinner>
                          </div>
                          <ng-container *ngIf="selectedNodeTitle; else noProps">
                            <vb-properties-pane
                              [style]="{ width: '100%' }"
                              [pageName]="'datamodel'"
                              [fsData]="fsData"
                              [dataModelOrders]="dataModelDataOrder"
                              [selectedPropertyTitle]="selectedNodeTitle"
                              class="properties-pane"
                              (templateValueChange)="onTemplateValueChange($event)"
                            >
                            </vb-properties-pane>
                          </ng-container>
                          <ng-template #noProps>
                            <div class="no-prop-text">{{ 'CLICK_PROPERTY_PANE' | translate }}</div>
                          </ng-template>
                        </div>
                      </ng-template>
                    </p-splitter>
                  </div>

                  <div class="spinner-container" *ngIf="isLoading">
                    <p-progress-spinner></p-progress-spinner>
                  </div>
                  <div *ngIf="showVisualizer">
                    <div class="spinner-container" *ngIf="visLoading">
                      <p-progress-spinner></p-progress-spinner>
                    </div>
                    <vb-data-model-visualizer
                      *ngIf="!visLoading"
                      [dataModelDataOrder]="dataModelDataOrder"
                      [referredTableData]="referredTableData"
                      [tablesInfo]="tablesInfo"
                      [tableMap]="tableMap"
                      [refAppMetaInfos]="refAppMetaInfos"
                      [fkDeats]="fkDeats"
                      [tableFieldMap]="tableFieldMap"
                      [complexTables]="complexTables"
                    ></vb-data-model-visualizer>
                  </div>

                  <div *ngIf="showDbVisualizer">
                    <app-dm-visualizer [tuples]="dataModelDataOrder$ | async"></app-dm-visualizer>
                  </div>
                </p-tabpanel>
                <p-tabpanel [value]="1">
                  <div
                    class="container-fluid sampledata-style sample-data-sheet jexcel-search-style .eva-v2-service-design clearfix"
                    id="generate-sample-data"
                  >
                    <div>
                      <div *ngIf="sampleDataLoading" class="d-flex justify-content-center">
                        <p-progress-spinner></p-progress-spinner>
                      </div>
                      <vb-vs-excel
                        *ngIf="sampleDataWorkSheet && sampleDataWorkSheet.length > 0"
                        [component]="'sampledata'"
                        [showSearch]="true"
                        [worksheets]="sampleDataWorkSheet"
                        (cellValueChange)="updateSampleData($event)"
                      ></vb-vs-excel>
                      <div
                        class="col-12 text-center"
                        *ngIf="sampleDataWorkSheet && sampleDataWorkSheet.length === 0 && !sampleDataLoading"
                      >
                        {{ 'NO_SAMPLE_DATA' | translate }}
                      </div>
                    </div>
                  </div>
                </p-tabpanel>
                <p-tabpanel [value]="2">
                  <div class="container-fluid">
                    <vb-querystring-list #querystringList></vb-querystring-list>
                  </div>
                </p-tabpanel>
              </p-tabpanels>
            </p-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-dialog
    header="Add Fields"
    [(visible)]="showPopup"
    [style]="{ width: '60vw' }"
    [draggable]="false"
    [resizable]="false"
    [modal]="true"
    [baseZIndex]="9999"
    appendTo="body"
    [closable]="false"
    (onShow)="setAddFieldsFocus()"
  >
    <form [formGroup]="appForm">
      <div class="row form-group align-items-start mt-3 mb-3">
        <label class="col-6 col-form-label required" for="name">{{ 'COMMA_SEPARATED_FIELD_NAMES' | translate }}</label>
        <div class="col-6">
          <textarea
            formControlName="name"
            id="name"
            type="name"
            class="form-control"
            [ngClass]="{ 'error-border': this.messages.addMultipleFields }"
            rows="4"
            required="required"
            #addFieldsInput
          ></textarea>
          <small *ngIf="this.messages && this.messages.addMultipleFields" class="input-error-text">
            <span [innerHtml]="this.messages.addMultipleFields"></span>
          </small>
        </div>
      </div>
    </form>
    <ng-template #footer>
      <div class="text-right update-form">
        <button type="button" class="btn btn-primary cancel-btn" (click)="cancelPopup(tableForm)">
          {{ 'CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary save-btn" (click)="createFields($event)">
          {{ 'SUBMIT' | translate }}
        </button>
      </div>
    </ng-template>
  </p-dialog>
  <p-dialog
    header="Add Table"
    [(visible)]="showTblPopup"
    [style]="{ width: '25vw' }"
    styleClass="addTable"
    [draggable]="false"
    [resizable]="false"
    [modal]="true"
    [baseZIndex]="9999"
    appendTo="body"
    [closable]="false"
  >
    <form [formGroup]="tableForm">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label required" for="name">Name</label>
        <div class="col-sm-9">
          <input
            formControlName="name"
            id="name"
            type="name"
            class="form-control"
            maxlength="128"
            minlength="1"
            required
            [ngClass]="{ 'error-border': this.messages && this.messages.name }"
          />
          <small *ngIf="this.messages && this.messages.name" class="input-error-text">
            <span [innerHtml]="this.messages.name"></span>
          </small>
        </div>
      </div>
      <div class="form-group row mb-0">
        <label class="col-sm-3 col-form-label required" for="type"
          >Type
          <i
            class="fa fa-info-circle field-info"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            tooltipPosition="bottom"
            pTooltip="Defines the table's purpose. It can be for storing and managing data (transactional), for analyzing data (analytical), or a combination of both. It can also be a custom view of existing data (Query View)."
          ></i
        ></label>
        <div class="col-sm-9 tbl-types">
          <p-select
            class="form-control"
            [options]="tableTypeOptions"
            optionLabel="name"
            optionValue="value"
            appendTo="body"
            formControlName="type"
            class="form-control"
            placeholder="Select"
          >
          </p-select>
        </div>
      </div>
    </form>
    <ng-template #footer>
      <div class="text-right update-form stylebutton">
        <div class="mt-2 mb-2">
          <button type="button" class="btn btn-primary cancel-btn" (click)="cancelPopup(tableForm)">
            {{ 'CANCEL' | translate }}
          </button>
          <button type="submit" class="btn btn-primary save-btn" (click)="createTable($event)">
            {{ 'CREATE' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
    <div *ngIf="isLoading" class="d-flex justify-content-center">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </p-dialog>
  <p-popover #op styleClass="datamodel-data-type" (onHide)="clearFilterData()">
    <ng-template #content>
      <div class="data-field-type searchbox-button">
        <div class="field">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
            <input
              [(ngModel)]="filter"
              name="filter"
              [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
              class=""
              id="filter"
              placeholder="Search"
              autocomplete="off"
            />
            <span class="p-inputgroup-addon us-input-clear-icon d-none" id="btnResetSearch"
              ><i class="pi pi-times"></i
            ></span>
          </div>
        </div>
      </div>
      <div class="data-type-items">
        <ng-container *ngFor="let type of types | uiFilter: filter : ['name']">
          <ng-container *ngIf="type.isDivider; then divider; else filterOrData"></ng-container>
          <ng-template #divider>
            <div [class]="type.class" class="dropdown-divider"></div>
          </ng-template>
          <ng-template #filterOrData>
            <ng-container *ngIf="type.isFilter; then filter; else data"></ng-container>
          </ng-template>
          <ng-template #data>
            <span
              [attr.value]="type.value"
              [class]="type.class"
              *ngIf="(hideDts && type.name !== 'File Attachment' && type.name !== 'Image Carousel') || !hideDts"
              class="dropdown-item"
              (click)="setDataType(type.value)"
              (keyup.enter)="setDataType(type.value)"
              tabindex="1"
              >{{ type.name }}</span
            >
          </ng-template>
        </ng-container>
        <span
          [attr.value]="'Complex Datatype'"
          [class]="cType.class"
          class="dropdown-item"
          [sid]="cType.value"
          (click)="setDataType('Complex Datatype', cType.value, cType.name)"
          (keyup.enter)="setDataType('Complex Datatype', cType.value, cType.name)"
          tabindex="2"
          *ngFor="let cType of complexTypesForDataType | uiFilter: filter : ['name']"
          >{{ cType.name }}</span
        >
      </div>
    </ng-template>
  </p-popover>
  <p-dialog
    [(visible)]="isMergeLogsPopupOpen"
    styleClass="ai-data-model-merge-error-modal"
    [draggable]="false"
    [modal]="true"
    appendTo="body"
    closable="isMergeLogsPopupOpen"
    [style]="{ width: '50vw' }"
  >
    <ng-template #header>
      <div class="d-flex flex-prototype">
        {{ 'AI_MERGE_LOG_HEADER' | translate }}
      </div>
    </ng-template>
    <div class="d-flex justify-content-center flex-column mt-2">
      <div class="list-err mb-2" *ngFor="let log of aiMergeErrorLogs; let i = index">
        <div *ngIf="getTypeOf(log) === 'string'">
          {{ log }}
        </div>
        <div *ngIf="getTypeOf(log) === 'object'">
          <div class="mb-2">Skipped Infos:</div>
          <div *ngFor="let skippedItem of log.skippedFieldInfo; let j = index" class="mb-2">
            {{ j + 1 }}. {{ skippedItem.name }} <span class="item-type">{{ skippedItem.type }}</span> -
            {{ skippedItem.reason }}
          </div>
        </div>
      </div>
    </div>
    <ng-template #footer>
      <div class="text-right update-form">
        <button type="button" class="btn btn-primary cancel-btn" (click)="closeMergingErrPopup()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    </ng-template>
  </p-dialog>

  <vb-blocker
    [blocked]="isAiDataModelMergeInProgress"
    [blockerType]="'GEN_AI_MERGE'"
    [positionCentered]="true"
    [isDisplayed]="isAiDataModelMergeInProgress"
  ></vb-blocker>
</div>
